import axios from 'axios';

import { getV2RootUrl, publicAxiosHeaderV2 } from 'common/helpers/apiHelper';

export const listReservationTypes = (customerId) => {
  let urlString = ``;
  if (customerId) {
    urlString += `&customerId=${customerId}`;
  }
  return axios.get(
    `${getV2RootUrl()}/experience/for-web?${urlString}`,
    publicAxiosHeaderV2()
  );
};

export const getReservationType = (slug, customerId) => {
  let urlString = ``;
  if (customerId) {
    urlString += `&customerId=${customerId}`;
  }
  return axios.get(
    `${getV2RootUrl()}/experience/slug/${slug}/for-web?${urlString}`,
    publicAxiosHeaderV2()
  );
};
